import { showSnackbar } from '@services/snackbar';
import { axiosInstances, getAxiosHeaders } from './config/axios';
import { routes } from './config/routes';

// generates hash for a mobile for tawkto
export const getHash = async (mobile: string) => {
  return axiosInstances.webWallet
    ?.post(routes.tawkto.hash, { mobile: mobile }, getAxiosHeaders())
    .then((res) => {
      if (res?.data?.code === 0) {
        return res?.data?.data?.hash;
      }
      return res?.data;
    })
    .catch((e) => {
      console.info(e);
      if (e?.response?.data?.code !== 105) {
        showSnackbar(e?.response?.data?.message, 'error');
      }
      return e?.response?.data;
    });
};
